type SettingsRecord = Record<string, unknown>

function isPlainObject(value: unknown): value is SettingsRecord {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

/**
 * The PATCH body that turns `stored` into `next` on the server, which merges
 * company settings key by key. Anything in `stored` that `next` drops or
 * leaves undefined is sent as null, which clears it there.
 */
export function settingsReplacementPatch(
  stored: SettingsRecord | undefined,
  next: SettingsRecord
): SettingsRecord {
  const patch: SettingsRecord = {}
  for (const key of Object.keys(stored ?? {})) {
    if (!(key in next) || next[key] === undefined) patch[key] = null
  }
  for (const [key, value] of Object.entries(next)) {
    if (value === undefined) continue
    const previous = stored?.[key]
    patch[key] =
      isPlainObject(value) && isPlainObject(previous)
        ? settingsReplacementPatch(previous, value)
        : value
  }
  return patch
}
